import axios from 'axios'
import Errors from './errors'
class Formit {
	/**
	 * Get things started.
	 */
	constructor() {
		this.isPending = false
		this.errors = new Errors()
		this.errorsData = {};

		['post', 'patch', 'put', 'delete'].forEach(method => {
			this[method] = (url, data, nonce) => {
				return this.submit(method, url, data, nonce)
			}
		})
	}

	/**
	 * Start processing of the form.
	 */
	startProcessing() {
		this.errors.clear()
		this.isPending = true
	}

	/**
	 * Finish processing the form.
	 */
	finishProcessing() {
		this.isPending = false
	}

	/**
	 * Clear form errors.
	 */
	clear() {
		this.errors.clear()
	}

	/**
	 * Submit the form to the given url with the method specified.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @param {Object} data
	 * @param {String} nonce
	 */
	submit(method, url, data = {}, nonce = false) {
		this.clear()
		this.startProcessing()

		if (nonce) {
			axios.defaults.headers.common['X-WP-Nonce'] = nonce
		}

		return new Promise((resolve, reject) => {
			axios[method.toLowerCase()](url, this.formData(data))
				.then(response => {
					resolve(response.data)
				})
				.catch(error => {
					this.handleError(error)
					reject(error)
				})
				.then(() => {
					this.finishProcessing()
				})
		})
	}

	/**
	 * Return the data object as a FormData object.
	 * @param {object} formData
	 */
	formData(data) {
		/*global FormData */
		/*eslint no-undef: "error"*/
		let formData = new FormData()

		for (const field in data) {
			formData.append(field, this.sanitize(data[field]))
		}

		return formData
	}

	/**
	 * Avoid to send strings "undefined" or "null" as the field's value.
	 * @param {mixed} value
	 */
	sanitize(value) {
		if (value === undefined || value === null) {
			return ''
		}
		return value
	}

	/**
	 * Handles an error response.
	 * @param {Object} response
	 */
	handleError(response) {
		// Only accepts responses with status 422.
		if (response.response.status === 422) {
			if (response.response.data.error_data) {
				this.errorsData = response.response.data.error_data
			}
			this.errors.set(response.response.data.errors)
		}
	}

	/**
	 * Clear errors on keydown.
	 * @param {KeyboardEvent} event
	 */
	onKeydown(event) {
		if (event.target.name) {
			this.errors.clear(event.target.name)
		}
	}
}

export default Formit



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit/src/main.js
// module id = null
// module chunks = 